import {get} from '@logistics-frontend/utils'

export const desktopComponents = {
  datepicker: import('@logistics-frontend/blocks/v2/datepicker/DatePicker').then(get('DatePicker')),
  'datepicker-range': import('@logistics-frontend/blocks/v2/datepicker/DatePicker').then(get('RangeDatePicker')),
  'datepicker-range-querysynced': import('@logistics-frontend/blocks/v2/datepicker/QuerySynced').then(
    get('QuerySyncedRangeDatePicker'),
  ),
  '@form/datepicker-range': import(
    '@logistics-frontend/form/src/components/range-date-picker/desktop/RangeDatePicker'
  ).then(get('RangeDatePicker')),
  '@form-v2/datepicker-range': import(
    '@logistics-frontend/form/v2/components/range-date-picker/desktop/RangeDatePicker'
  ).then(get('RangeDatePicker')),
} as const

export const mobileComponents = {
  datepicker: import('@logistics-frontend/blocks/v2/datepicker/DatePicker@mobile').then(get('DatePickerMobile')),
  'datepicker-range': import('@logistics-frontend/blocks/v2/datepicker/DatePicker@mobile').then(
    get('RangeDatePickerMobile'),
  ),
  'datepicker-range-querysynced': import('@logistics-frontend/blocks/v2/datepicker/QuerySynced@mobile').then(
    get('QuerySyncedRangeDatePickerMobile'),
  ),
  '@form/datepicker-range': import(
    '@logistics-frontend/form/src/components/range-date-picker/mobile/RangeDatePicker'
  ).then(get('RangeDatePicker')),
  '@form-v2/datepicker-range': import(
    '@logistics-frontend/form/v2/components/range-date-picker/mobile/RangeDatePicker'
  ).then(get('RangeDatePicker')),
} as const
